import React, {
  useEffect,
  useState,
  useMemo,
  useReducer,
  Fragment
} from "react"
import { useDispatch } from "react-redux"
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
  Typography
} from "@material-ui/core"
import CommunicationTextAccordion from "./CommunicationTextAccordion"
import { getMembers } from "actions/organization"
import SendTextDialog from "./SendTextDialog"
import useStyles from "./styles"

const intialState = {
  administrator: {
    groupName: "Administrator",
    users: [],
    selected: [],
    allSelected: false
  },
  moderator: {
    groupName: "Moderators",
    users: [],
    selected: [],
    allSelected: false
  },
  user: {
    groupName: "Users",
    users: [],
    selected: [],
    allSelected: false
  }
}

function reducer(state, action) {
  switch (action.type) {
    case "UPDATE_USERS":
      const newState = {
        administrator: {
          ...state.administrator,
          users: [...action.data.administrator.users]
        },
        moderator: {
          ...state.moderator,
          users: [...action.data.moderator.users]
        },
        user: { ...state.user, users: [...action.data.user.users] }
      }

      return { ...state, ...newState }
    case "SELECT_USERS": {
      const prevSelected = state[action.data.groupKey].selected
      const newSelected = action.data.selected
      let updatedSelected = []

      if (prevSelected.indexOf(newSelected) === -1) {
        updatedSelected = [...prevSelected, newSelected]
      } else {
        updatedSelected = prevSelected.filter(id => id !== newSelected)
      }

      return {
        ...state,
        [action.data.groupKey]: {
          ...state[action.data.groupKey],
          selected: updatedSelected
        }
      }
    }
    case "SELECT_ALL": {
      let updatedSelected = []
      let updatedAllSelected = false
      if (!state[action.data.groupKey].allSelected) {
        updatedSelected = state[action.data.groupKey].users.map(user => user.id)
        updatedAllSelected = true
      }

      return {
        ...state,
        [action.data.groupKey]: {
          ...state[action.data.groupKey],
          selected: updatedSelected,
          allSelected: updatedAllSelected
        }
      }
    }
    case "RESET_SELECTED": {
      const updatedState = { ...state }

      Object.keys(updatedState).map(key => {
        updatedState[key].selected = []
      })

      return updatedState
    }
    default:
      throw new Error(`Reducer cannot resolve action type of ${action.type}`)
  }
}

const CommunicationText = () => {
  const classes = useStyles()
  const [textMessageValue, setTextMessageValue] = useState("")
  const [userGroups, userGroupDispatch] = useReducer(reducer, intialState)
  const [loading, setLoading] = useState(true)
  const [openDialog, setOpenDialog] = useState(false)
  const [expanded, setExpanded] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getMembers())
      .then(res => {
        const groups = {
          administrator: { users: [] },
          moderator: { users: [] },
          user: { users: [] }
        }

        res.users.forEach(user => {
          const formatedUser = {
            id: user.id,
            name: `${user.first_name} ${user.last_name}`
          }

          groups[user.role.toLowerCase()].users = [
            ...groups[user.role.toLowerCase()].users,
            formatedUser
          ]
        })

        userGroupDispatch({ type: "UPDATE_USERS", data: groups })
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        setLoading(false)
      })
  }, [])

  function handleTextAreaChange(e) {
    const value = e.currentTarget.value.slice(0, 160)
    const count = value.length
    if (count <= 160) {
      setTextMessageValue(value)
    }
  }

  const totalSelectedCount = useMemo(() => {
    return Object.keys(userGroups)
      .map(key => userGroups[key].selected.length)
      .reduce((acc, val) => val + acc)
  }, [userGroups])

  const userList = useMemo(() => {
    let list = []
    Object.keys(userGroups).forEach(key =>
      userGroups[key].users.forEach(user => {
        if (userGroups[key].selected.includes(user.id)) {
          list.push(user.name)
        }
      })
    )
    return list
  }, [userGroups])

  function toggleDialog() {
    setOpenDialog(status => !status)
  }

  const handleExpand = panel => (e, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <Fragment>
      <Typography variant="h5">Text messages</Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            className={classes.TextArea}
            rows="5"
            variant="outlined"
            multiline
            placeholder="Create your message here"
            value={textMessageValue}
            onChange={handleTextAreaChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Typography>
                    {textMessageValue.length}/160 characters
                  </Typography>
                </InputAdornment>
              )
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Typography className={classes.selectMember}>
            Select members
          </Typography>
          {!loading ? (
            <Fragment>
              <CommunicationTextAccordion
                userGroups={userGroups}
                userGroupDispatch={userGroupDispatch}
                handleExpand={handleExpand}
                expanded={expanded}
              />
            </Fragment>
          ) : (
            <Box display="flex" justifyContent="center">
              <CircularProgress
                classes={{ colorPrimary: classes.spinnerColor }}
              />
            </Box>
          )}
        </Grid>
        <Grid item xs={12} lg={4}>
          <Button
            className={classes.sendButton}
            variant="contained"
            color="primary"
            onClick={toggleDialog}
            disabled={textMessageValue === "" || userList.length === 0}
          >
            Send ({totalSelectedCount})
          </Button>
          <Typography className={classes.userList}>
            {userList.join(", ")}
          </Typography>
        </Grid>
      </Grid>
      <SendTextDialog
        openDialog={openDialog}
        toggleDialog={toggleDialog}
        userGroups={userGroups}
        userList={userList}
        textMessageValue={textMessageValue}
        setTextMessageValue={setTextMessageValue}
        userGroupDispatch={userGroupDispatch}
        setExpanded={setExpanded}
      />
    </Fragment>
  )
}

export default CommunicationText



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationText/index.jsx